const action = (type: string, value: any) => {
    return {
      type: type,
      value: value
    }
  };

export default action;
